import { createCommonUtilsApi } from "../../api-helpers/CommonUtilsApiHelper";
import { Lookup } from "../../interfaces/allergy";
import { CommonDropdown } from "./CommonDropdown";

export interface Props {
  label: string;
  type: string;
  onChange: (selection?: Lookup) => void;
  disabled: boolean;
  required: boolean;
  initialValue?: string | Lookup;
  changeSelectionKey?: string
}

export const LookupDropdown = ({ label, type, onChange, disabled, required, initialValue, changeSelectionKey }: Props) => {
  const lookupApi = createCommonUtilsApi();

  const loadData = async (): Promise<Lookup[]> => {
    if (!type) {
      return [];
    }
    
    const response = await lookupApi.lookupControllerFindAll(type);
    return response.data;
  };

  return (
    <CommonDropdown
      label={label}
      keyProvider={lookup => lookup.id}
      labelProvider={lookup => lookup.name}
      dataProvider={loadData}
      onChange={onChange}
      disabled={disabled}
      required={required}
      initialValue={initialValue}
      changeSelectionKey={changeSelectionKey}
      ></CommonDropdown>
  );
};
